/* "My bag" popover: the cart drawer is restyled as a card that drops from the header (see beacon-v2.css, #cart-drawer).
   This only measures where the header ends so the card sits just under it. */
(function () {
  function place() {
    var dlg = document.querySelector('#cart-drawer dialog');
    var hdr = document.querySelector('header, .header');
    if (!dlg || !hdr) return;
    var bottom = Math.max(hdr.getBoundingClientRect().bottom, 0);
    dlg.style.setProperty('--bbag-top', Math.round(bottom + 12) + 'px');
  }
  function watch() {
    var dlg = document.querySelector('#cart-drawer dialog');
    place();
    if (dlg && window.MutationObserver) new MutationObserver(place).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }
  document.addEventListener('theme-drawer:open', place);
  window.addEventListener('resize', place);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
